import { loadDefaultJapaneseParser } from "budoux";
const parser = loadDefaultJapaneseParser();

// https://github.com/google/budoux/blob/main/javascript/README.md
export const budoux = (container) => {
  const targets = container.querySelectorAll("[data-budoux]");

  targets.forEach((target) => {
    target.innerHTML = `<span>${target.innerHTML}</span>`;

    const newSpan = target.firstChild;

    window.addEventListener("resize", () => {
      target.style.minHeight = newSpan.clientHeight + "px";
    });

    parser.applyElement(newSpan);
  });

  // 画面内に表示された時の処理
  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.style.minHeight = entry.target.firstChild.clientHeight + "px";
        }
      }
    },
    {
      root: null,
      rootMargin: "0px",
      threshold: 0,
    }
  );

  targets.forEach((target) => observer.observe(target));
};
